import {Alert, Button, Col, Container, GoBack, Icon, Input, Row, Select} from "design-react-kit";
import {useLocation, useNavigate} from "react-router-dom";
import React, {useState} from "react";
import {properties} from "../../../config/properties";


const styles = {

    sidebar: {
        backgroundColor: "#0b5ed7", // blu
        padding: "1rem",
        borderRadius: "8px",
        minWidth: "180px",
        color: "white",
        fontWeight: "600",
    },
    sidebarButton: {
        margin: "0.5rem 0",
        width: "100%",
    },
    card1: {
        padding: "2rem",
        borderRadius: "12px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        width: "100%",
        maxWidth: "600px",
    },
    card: {
        padding: '2rem',
        borderRadius: '12px',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
        //boxShadow: '0 6px 18px rgba(0, 0, 0, 0.06)',
        //border: 'none',
        border: '1px solid #ddd',
        transition: 'transform 0.2s ease-in-out',
    },
    cardTitle: {
        padding: '2rem',
        borderRadius: 'none',
        backgroundColor: '#fefefe',
        boxShadow: '0 8px 24px #fefefe',
        transition: 'transform 0.2s ease-in-out',
    },
    cardTitle1: {
        backgroundColor: "#0b5ed7",
        color: "white",
        padding: "1rem",
        borderRadius: "8px",
        marginBottom: "2rem",
        textAlign: "center",
        fontSize: "1.5rem",
        fontWeight: 600,
    },
    titleIcon: {
        marginRight: '0.75rem',
    },
    sectionTitle: {
        fontSize: '1.1rem',
        fontWeight: '700',
        color: '#0b5ed7',
        borderBottom: '2px solid #0b5ed7',
        paddingBottom: '0.25rem',
        marginBottom: '1rem',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    fieldLabel: {
        fontWeight: '500',
        color: '#6c757d',
        marginBottom: '0.25rem',
        fontSize: '0.9rem',
    },
    fieldValue: {
        marginBottom: '1rem',
        fontWeight: '600',
        fontSize: '1rem',
        color: '#212529',
    },
};


const ModificaDelegaPersona = ({user}) => {

    const convertToInputDate = (dateStr) => {
        if (!dateStr) return '';
        const [day, month, year] = dateStr.split('-');
        return `${year}-${month}-${day}`;
    };


    const location = useLocation();
    const { delega } = location.state || {};
    const { idProfilo } = location.state || {};
    const {nomeProfilo} = location.state || {}
    const {cognomeProfilo} = location.state || {}
    const navigate = useNavigate();

    const [dataInizio, setDataInizio] = useState(convertToInputDate(delega.dataInizio));
    const [dataFine, setDataFine] = useState(delega.dataFine !== null ? convertToInputDate(delega.dataFine) : '');

    const [note, setNote] = useState(delega.note !== null ? delega.note : null)

    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });


    const handleConferma = async (e) => {

        e.preventDefault();

        try {

            setAlert({ visible: false, type: '', message: '' });

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/update/personaDelega`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ dataInizio : dataInizio, dataFine: dataFine, idPersonaDelega : delega.idPersonaDelega, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente }),
            });


            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            const json = await res.json();

            navigate( '/private/gestioneDeleghePersona', { state: { esito: json , idProfilo : idProfilo, nomeProfilo : nomeProfilo , cognomeProfilo : cognomeProfilo } });


        } catch (e) {

            const json = {

                esito : "KO",
                messaggio: "Errore del server."
            }

            navigate( '/private/gestioneDeleghePersona', { state: { esito: json , idProfilo : idProfilo, nomeProfilo : nomeProfilo , cognomeProfilo : cognomeProfilo } });
        }
    };



    return (

        <div className="bg-white py-lg-5">

            <Container className={"py-lg-5"}>

                <div className={"pb-5"}>

                    <h2>Delega di {nomeProfilo} {cognomeProfilo}</h2>

                </div>

                <Row>
                    <Col md={9}>



                        <div style={styles.card}>

                            <h2 style={styles.sectionTitle}>
                                <Icon icon="it-key" size="sm" style={styles.titleIcon}/>
                                Dati della delega
                            </h2>

                            {alert.visible && (
                                <Alert color={alert.type} isOpen={alert.visible}
                                       toggle={() => setAlert({...alert, visible: false})}>
                                    {alert.message}
                                </Alert>
                            )}

                            <form onSubmit={handleConferma}>

                                <div style={{
                                    backgroundColor: "#f8f9fa", // grigio chiaro per evidenziare
                                    padding: "1.5rem",
                                    borderRadius: "8px",
                                    border: "1px solid #dee2e6",
                                }}>

                                    <div className="mb-3">
                                        <p style={styles.fieldLabel}>Delega</p>
                                        <p style={{...styles.fieldValue, fontSize: "x-large"}}>
                                            {delega.descrizione || "-"}
                                        </p>

                                    </div>


                                    <div className="mb-3" style={{width:'40%'}}>
                                        <label style={styles.fieldLabel}>Data Inizio</label>
                                        {/* Qui puoi inserire l'input effettivo */}
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={dataInizio}
                                            onChange={(e) => setDataInizio(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-4" style={{width:'40%'}}>
                                        <label style={styles.fieldLabel}>Data Fine</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={dataFine || ''}
                                            min={dataInizio}
                                            onChange={(e) => {
                                                const selectedDate = e.target.value;
                                                if (selectedDate >= dataInizio) {
                                                    setDataFine(selectedDate);
                                                } else {
                                                    setDataFine(''); // oppure potresti ignorare il set
                                                }
                                            }}
                                        />
                                    </div>

                                    <div className="mb-4">
                                        <p style={styles.fieldLabel}>Note : </p>
                                        <p style={{...styles.fieldValue, fontSize: "x-large"}}> {note || "-"}</p>

                                    </div>

                                    <div className={"pb-2 text-end"}>

                                        <Button
                                            color="primary"
                                            style={styles.titleIcon}
                                            onClick={() => {
                                                navigate('/private/gestioneDeleghePersona', {
                                                    state: {
                                                        idProfilo: idProfilo,
                                                        nomeProfilo: nomeProfilo,
                                                        cognomeProfilo: cognomeProfilo
                                                    }
                                                });
                                            }}
                                        >
                                            Indietro
                                        </Button>

                                        <Button
                                            color="primary"

                                        >
                                            Conferma
                                        </Button>
                                    </div>

                                </div>

                            </form>
                        </div>


                    </Col>
                </Row>


            </Container>

        </div>


    );


}
export default ModificaDelegaPersona;